import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

let serviceName: string | null = null;

export function bootService (name: string, { initSentry = true }: { initSentry?: boolean } = {}) {
  serviceName = name;
  if (initSentry) {
    Sentry.init({
      dsn: "https://6ad4de9909784c4bb4c68dee6f0fb1e9@o4504362017095680.ingest.sentry.io/4504362019192833",
      environment: process.env.NODE_ENV || 'local',
      integrations: [new BrowserTracing()],
      tracesSampleRate: 0.1,
      initialScope: {
        tags: {
          serviceName
        }
      }
    });
  }
}
